import  Poptip from './Poptip'
export default Poptip



// WEBPACK FOOTER //
// ./components/Poptip/index.js